import type { PServed } from '@wui/im'

import { useStoreConfiguration } from '@/shared/store/configuration'
import { GUEST_PREFIX, PSTNGUEST } from '@/shared/utils/constants'

const PREFIX = '<sip:'
const ROOM_PREFIX = 'ROOMS-'
const PSTN_GUEST_PREFIX = `${PSTNGUEST}-`

export const parseGuidFromPServed = (pServed: string): string => {
  return pServed.split(':')[1]?.split('@')[0] ?? ''
}

export const toPServedUser = (id: string, isRoom: boolean): string => {
  if (id?.includes(PREFIX)) {
    console.warn(`The string: ${id} is already like p served format`)
  }
  const { domainPath } = useStoreConfiguration()
  return isNotPServed(id) ? `${PREFIX}${isRoom ? ROOM_PREFIX : ''}${id}@${domainPath}>` : id
}

export const fromPServedUser = (pServedUser: string): string => {
  const { domainPath } = useStoreConfiguration()
  return pServedUser.replace(new RegExp(`<sip:ROOMS-|<sip:|@${domainPath}>`, 'g'), '')
}

export const fromPServedUserIfRoom = (pServedUser: string): string => {
  if (pServedIsRoom(pServedUser)) {
    return fromPServedUser(pServedUser)
  }
  return pServedUser
}

export const pServedIsRoom = (pServedUser: string): boolean => {
  return pServedUser?.startsWith(`${PREFIX}${ROOM_PREFIX}`)
}

export const isPServedIsUser = (pServed: string): boolean => {
  const { domainPath } = useStoreConfiguration()
  return new RegExp(`${PREFIX}([0-9]*)@${domainPath}>`).test(pServed)
}

export const isNotPServed = (input: string): boolean => {
  return input.search(`${PREFIX}(.*)@(.*)>`) === -1
}

export const isPstnGuest = (number: string) => {
  return number.startsWith(PSTN_GUEST_PREFIX)
}

export const getNumberFromPstn = (number: string) => {
  return number.replace(PSTN_GUEST_PREFIX, '')
}

export const isGuest = (number: string) => {
  return number.startsWith(GUEST_PREFIX)
}

export const getStreamIdFromPServedUser = (pServedUser: PServed): string => {
  return `-${fromPServedUser(pServedUser).replace('GUEST-', '')}`
}

export function numberToUri (number: string): string {
  const { domainPath } = useStoreConfiguration()
  return `${PREFIX}${number}@${domainPath}>`
}

export function getPServedFromString (value: string) {
  const { domainPath } = useStoreConfiguration()
  return value.includes(PREFIX) ? value : `${PREFIX}${value}@${domainPath}>`
}
